<template>
  <p class="social-links">
    <a
      v-if="facebookLink"
      id="social-link-facebook"
      :href="facebookLink"
      target="_blank"
      :title="facebookTitle">
      <span class="no-text">Visit Us on Facebook</span>
      <svgicon
        original
        data="@iconPath/glyph/24/logo-facebook.svg?inline"
        width="24"
        height="24"></svgicon>
    </a>
    <a
      v-if="twitterLink"
      id="social-link-twitter"
      :href="twitterLink"
      target="_blank"
      :title="twitterTitle">
      <span class="no-text">Visit Us on Twitter</span>
      <svgicon
        original
        data="@iconPath/glyph/24/logo-twitter.svg?inline"
        width="24"
        height="24"></svgicon>
    </a>
    <a
      v-if="linkedinLink"
      id="social-link-linkedin"
      :href="linkedinLink"
      target="_blank"
      :title="linkedinTitle">
      <span class="no-text">Visit Us on LinkedIn</span>
      <svgicon
        original
        data="@iconPath/glyph/24/logo-linkedin.svg?inline"
        width="24"
        height="24"></svgicon>
    </a>
    <a
      v-if="youtubeLink"
      id="social-link-youtube"
      :href="youtubeLink"
      target="_blank"
      :title="youtubeTitle">
      <span class="no-text">Visit Us on YouTube</span>
      <svgicon
        original
        data="@iconPath/glyph/24/logo-youtube.svg?inline"
        width="24"
        height="24"></svgicon>
    </a>
    <a
      v-if="instagramLink"
      id="social-link-instagram"
      :href="instagramLink"
      target="_blank"
      :title="instagramTitle">
      <span class="no-text">Visit Us on Instagram</span>
      <svgicon
        original
        data="@iconPath/glyph/24/logo-instagram.svg?inline"
        width="24"
        height="24"></svgicon>
    </a>
  </p>
</template>

<script>
export default {
  name: 'SocialLinksComponent',
  props: {
    facebookLink: String,
    twitterLink: String,
    linkedinLink: String,
    youtubeLink: String,
    instagramLink: String
  },
  data() {
    return {
      facebookTitle: 'Visit Us on Facebook',
      twitterTitle: 'Visit Us on Twitter',
      linkedinTitle: 'Visit Us on LinkedIn',
      youtubeTitle: 'Visit Us on YouTube',
      instagramTitle: 'Visit Us on Instagram'
    }
  }
}
</script>
